class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartItems = document.querySelector('cart-items');
    this.miniCart = document.getElementById('mini-cart');
  }

  vanillaSerialize (data) {
    let obj = {};
    for (let [key, value] of data) {
      if (obj[key] !== undefined) {
        if (!Array.isArray(obj[key])) {
          obj[key] = [obj[key]];
        }
        obj[key].push(value);
      } else {
        obj[key] = value;
      }
    }
    return obj;
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');
    const formData = new FormData(this.form);
    let lineItemMessage = '';

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    let itemsArr = [];
    const prodID = this.form.querySelector('input[name="id"]').value;
    const preorderMessages = document.getElementsByClassName('preorder-message');
    for (let i = 0; i < preorderMessages.length; i++) {
      if(preorderMessages[i].classList.contains('active')){
        lineItemMessage = preorderMessages[i].textContent.trim();
      }
    }

    if(!lineItemMessage) {
      itemsArr.push({
        id: prodID,
        quantity: 1,
      });
    } else {
      itemsArr.push({
        id: prodID,
        quantity: 1,
        properties: {
          "Preorder": lineItemMessage
        }
      });
    }

    const body = JSON.stringify({
      items: itemsArr,
      sections: this.cartItems.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      if (parsedState.status == 422) {
        document.querySelector('.mini-cart-add-error').classList.remove('hidden');
        this.miniCart?.open();
      } else {
        document.querySelector('.mini-cart-add-error').classList.add('hidden');
        this.cartItems.renderContents(parsedState);

        if (!parsedState.sections) {
          fetch(window.location.href.split('?')[0]+`?sections=${this.cartItems.getSectionsToRender().map((section) => section.id)}`)
          .then((response) => response.json())
          .then((parsedState) => {
            const sectionPass = {sections: parsedState};
            this.cartItems.renderContents(sectionPass);
          });
        }
        return this.cartItems.checkGifts();
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });
  }
}

customElements.define('product-form', ProductForm);
